import React, { useEffect, useRef } from 'react';
import { ClipboardCheckIcon, CalendarIcon, UploadIcon, BookOpenIcon, TagIcon, ArrowRightIcon } from 'lucide-react';
export const ProgramsSection = () => {
  const sectionRef = useRef(null);
  const dotRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const features = [{
    icon: <CalendarIcon className="h-6 w-6 text-aqua" data-id="element-4149" />,
    text: 'Daily and weekly compliance tasks'
  }, {
    icon: <UploadIcon className="h-6 w-6 text-aqua" data-id="element-4150" />,
    text: 'Upload and track reports'
  }, {
    icon: <ClipboardCheckIcon className="h-6 w-6 text-aqua" data-id="element-4151" />,
    text: 'Log actions and notes'
  }, {
    icon: <BookOpenIcon className="h-6 w-6 text-aqua" data-id="element-4152" />,
    text: 'Access full resource libraries'
  }, {
    icon: <TagIcon className="h-6 w-6 text-aqua" data-id="element-4153" />,
    text: 'Discounts on staff training'
  }];
  return <section ref={sectionRef} className="py-24 bg-charcoal text-white opacity-0 transition-opacity duration-1000 relative overflow-hidden" style={{
    backgroundImage: 'radial-gradient(circle at 30% 70%, rgba(11, 117, 122, 0.2) 0%, transparent 70%), radial-gradient(circle at 70% 30%, rgba(29, 219, 219, 0.1) 0%, transparent 70%)'
  }} data-id="element-4154">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-4155">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-4156">
          <div data-id="element-4157">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 tracking-tight" data-id="element-4158">
              Go Beyond Courses → <br data-id="element-4159" />
              Structured Compliance Programs
            </h2>
            <div className="space-y-5 mb-10" data-id="element-4160">
              {features.map((feature, index) => <div key={index} className="flex items-center bg-white/5 backdrop-blur-sm p-5 rounded-lg border border-white/10 hover:bg-white/10 transition-all duration-300 transform hover:-translate-x-1" data-id="element-4161">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-4162">
                    {feature.icon}
                  </div>
                  <span className="text-white text-lg" data-id="element-4163">{feature.text}</span>
                </div>)}
            </div>
            <a href="/programs" className="inline-flex items-center px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-4164">
              Explore Programs
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-4165" />
            </a>
          </div>
          <div className="relative" data-id="element-4166">
            <div className="rounded-xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:scale-[1.02] hover:shadow-[0_20px_50px_rgba(29,219,219,0.2)]" data-id="element-4167">
              <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Compliance Programs Dashboard" className="w-full h-full object-cover" data-id="element-4168" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent" data-id="element-4169"></div>
            </div>
            <div className="absolute -bottom-8 -left-8 bg-white p-5 rounded-lg shadow-xl" data-id="element-4170">
              <div className="flex items-center" data-id="element-4171">
                <div ref={dotRef} className="h-4 w-4 rounded-full bg-aqua mr-3 animate-pulse" data-id="element-4172"></div>
                <span className="text-charcoal font-bold text-lg" data-id="element-4173">
                  Live Compliance Tracking
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};